import React, { useEffect, useState } from 'react';
import { withStyles, withTheme } from '@material-ui/core';
import StackedBarChart from '../../../../../common/Charts/StackedBarChart';
import { getChartConfig, getFormattedGraphData } from './utils';
import ToggleButton from './components/ToggleButton';
import { compose } from 'recompose';

const styles = (theme) => ({
  container: {
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
    border: `1px solid ${theme.AppBGColor}`,
    borderRadius: 5,
    padding: 10
  },
  header: {
    color: theme.palette.primary.main,
    fontSize: theme.headerTextFontSize,
    fontWeight: 600,
    marginBottom: 18
  },
  chartArea: {
    flex: 1,
    minHeight: 150
  },
  toggleButtonContainer: {
    marginBottom: 10
  }
});

const UsageGraph = ({ classes, theme, data, selectedTerminal }) => {
  const [isPercentage, setIsPercentage] = useState(false);
  const [graphData, setGraphData] = useState([]);

  useEffect(() => {
    const formattedGraphData = getFormattedGraphData(data, selectedTerminal);
    setGraphData(formattedGraphData);
  }, [data, selectedTerminal]);

  const chartConfig = getChartConfig(isPercentage, theme);

  return (
    <div className={classes.container}>
      <div className={classes.header}>Total Manually Created and Adjusted Routes by Date</div>
      <div className={classes.chartArea}>
        <StackedBarChart data={graphData} chartConfig={chartConfig} />
      </div>
      <div className={classes.toggleButtonContainer}>
        <ToggleButton isPercentage={isPercentage} setIsPercentage={setIsPercentage} />
      </div>
    </div>
  );
};

export default compose(withStyles(styles), withTheme())(UsageGraph);
